"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.allDates = exports.intersectingDates = exports.dateParser = exports.dateFormat = exports.isDateType = void 0;
const lodash_1 = __importDefault(require("lodash"));
const monthToIdx = {
  jan: 0,
  feb: 1,
  mar: 2,
  apr: 3,
  may: 4,
  jun: 5,
  jul: 6,
  aug: 7,
  sep: 8,
  oct: 9,
  nov: 10,
  dec: 11,
  '01': 0,
  '02': 1,
  '03': 2,
  '04': 3,
  '05': 4,
  '06': 5,
  '07': 6,
  '08': 7,
  '09': 8,
  10: 9,
  11: 10,
  12: 11,
  q1: 0,
  q2: 3,
  q3: 6,
  q4: 9
};
const monthToFull = {
  jan: 'January',
  feb: 'February',
  mar: 'March',
  apr: 'April',
  may: 'May',
  jun: 'June',
  jul: 'July',
  aug: 'August',
  sep: 'September',
  oct: 'October',
  nov: 'November',
  dec: 'December'
};
const monthToQuarter = {
  jan: 'Q1',
  feb: 'Q1',
  mar: 'Q1',
  apr: 'Q2',
  may: 'Q2',
  jun: 'Q2',
  jul: 'Q3',
  aug: 'Q3',
  sep: 'Q3',
  oct: 'Q4',
  nov: 'Q4',
  dec: 'Q4'
};
const isDateType = type => ['years', 'yearly', 'quarters', 'quarterly', 'months', 'monthly', 'weeks', 'weekly', 'days', 'daily', 'daysfull', 'dailyfull'].includes(String(type).toLowerCase());
exports.isDateType = isDateType;
const dateParserYear = date => {
  try {
    const parsedDate = new Date(Date.UTC(date, 0));
    if (parsedDate.toString() !== 'Invalid Date') {
      return parsedDate;
    }
  } catch (e) {
    return false;
  }
  return false;
};
const dateParserMonth = date => {
  try {
    let parsedDate = null;
    const [part1, part2] = date.split(/[ -/]/);
    if (monthToIdx[part1.toLowerCase()] !== undefined) {
      // Mon-YYYY
      parsedDate = new Date(Date.UTC(part2, monthToIdx[part1.toLowerCase()]));
    } else if (monthToIdx[part2.toLowerCase()] !== undefined) {
      // YYYY-MM
      parsedDate = new Date(Date.UTC(part1, monthToIdx[part2.toLowerCase()]));
    } else {
      parsedDate = new Date(Date.UTC(part2, part1));
    }
    if (parsedDate.toString() !== 'Invalid Date') {
      return parsedDate;
    }
  } catch (e) {
    return false;
  }
  return false;
};
const dateParserDay = date => {
  try {
    let parsedDate = null;
    const [year, month, day] = date.split(/[ -/]/);
    const parsedDay = day ? Number.parseInt(day, 10) : 1; // parseInt so we catch eg '1st'
    if (monthToIdx[month.toLowerCase()] !== undefined) {
      parsedDate = new Date(Date.UTC(year, monthToIdx[month.toLowerCase()], parsedDay));
    } else {
      parsedDate = new Date(Date.UTC(year, month, parsedDay));
    }
    if (parsedDate.toString() !== 'Invalid Date') {
      return parsedDate;
    }
  } catch (e) {
    return false;
  }
  return false;
};
const dateFormat = function (date) {
  let type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'years';
  if (type.toLowerCase() === 'items') return date;
  const [, day, month, year] = date.toUTCString().split(' ');
  if (type.toLowerCase() === 'months' || type.toLowerCase() === 'monthly') {
    return `${month} ${year}`;
  }
  if (type.toLowerCase() === 'monthsfull' || type.toLowerCase() === 'monthlyfull') {
    return `${monthToFull[month.toLowerCase()]} ${year}`;
  }
  if (type.toLowerCase() === 'quarters' || type.toLowerCase() === 'quarterly') {
    return `${monthToQuarter[month.toLowerCase()]} ${year}`;
  }
  if (type.toLowerCase() === 'days' || type.toLowerCase() === 'daily' || type.toLowerCase() === 'weeks' || type.toLowerCase() === 'weekly') {
    return `${month} ${day.replace(/^0+/, '')}, ${year}`;
  }
  if (type.toLowerCase() === 'dailyfull' || type.toLowerCase() === 'daysfull') {
    return `${monthToFull[month.toLowerCase()]} ${day.replace(/^0+/, '')}, ${year}`;
  }
  return year;
};
exports.dateFormat = dateFormat;
const dateParser = function (date) {
  let type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'years';
  if (!(0, exports.isDateType)(type.toLowerCase())) {
    return date;
  }
  try {
    let parsedDate = null;
    if (type.toLowerCase() === 'months' || type.toLowerCase() === 'monthly' || type.toLowerCase() === 'quarters' || type.toLowerCase() === 'quarterly') {
      parsedDate = dateParserMonth(date);
    } else if (type.toLowerCase() === 'days' || type.toLowerCase() === 'daily' || type.toLowerCase() === 'daysfull' || type.toLowerCase() === 'dailyfull' || type.toLowerCase() === 'weeks' || type.toLowerCase() === 'weekly') {
      parsedDate = dateParserDay(date);
    } else {
      parsedDate = new Date(Date.UTC(date, 0));
    }
    if (parsedDate) {
      return parsedDate;
    }
  } catch (e) {
    const yearDate = dateParserYear(date);
    if (yearDate) return yearDate;
    throw new Error(`Date ${date} is invalid`);
  }
  const yearDate = dateParserYear(date);
  if (yearDate) return yearDate;
  throw new Error(`Date ${date} is invalid`);
};
exports.dateParser = dateParser;
const intersectingDates = function () {
  let data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  const allDates = (0, lodash_1.default)(data).map(function () {
    let {
      x_type,
      data: values = []
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return (0, lodash_1.default)(values).map(_ref => {
      let {
        key
      } = _ref;
      return {
        key,
        x_type
      };
    }).filter(_ref2 => {
      let {
        key
      } = _ref2;
      return key;
    }).value();
  }).sortBy('key').value();
  const intersectingDates = lodash_1.default.intersectionWith(...allDates, (a, b) => a.key === b.key && a.x_type === b.x_type);
  return (0, lodash_1.default)(intersectingDates).map(_ref3 => {
    let {
      key,
      x_type
    } = _ref3;
    const date = (0, exports.dateParser)(key, x_type);
    return {
      key: date,
      formatted: (0, exports.dateFormat)(date, x_type),
      unformatted: key
    };
  }).sortBy(_ref4 => {
    let {
      key
    } = _ref4;
    return key.getTime();
  }).value();
};
exports.intersectingDates = intersectingDates;
const allDates = function () {
  let data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  const allDates = (0, lodash_1.default)(data).map(function () {
    let {
      x_type,
      data: values = []
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return (0, lodash_1.default)(values).map(_ref5 => {
      let {
        key
      } = _ref5;
      return {
        key,
        x_type
      };
    }).filter(_ref6 => {
      let {
        key
      } = _ref6;
      return key;
    }).value();
  }).sortBy('key').value();
  return (0, lodash_1.default)(allDates).flatten().map(_ref7 => {
    let {
      key,
      x_type
    } = _ref7;
    const date = (0, exports.dateParser)(key, x_type);
    return {
      key: date,
      formatted: (0, exports.dateFormat)(date, x_type),
      raw: key
    };
  }).uniqBy(_ref8 => {
    let {
      key
    } = _ref8;
    return key.getTime();
  }).sortBy(_ref9 => {
    let {
      key
    } = _ref9;
    return key.getTime();
  }).value();
};
exports.allDates = allDates;